import React from "react";
import { Link, useLocation } from "react-router-dom";
import { canAccessRoute } from "../../security/routes";
import "./PaymentTabs.css";

export const paymentTabs = [
  { page: "RecordPayment", label: "Record a Payment" },
  { page: "RecordExpenses", label: "Record an Expense" },
  { page: "PaymentApproval", label: "View Records" },
  { page: "CreatePayment", label: "Create Payment Request" },
  { page: "UploadPayments", label: "Upload Payments" },
];

export function isPaymentRoute(path) {
  const page = path.split("/")[2];
  return paymentTabs.some((tab) => tab.page === page) || ["Spendings", "Convert"].includes(page);
}

export function getPaymentsPath() {
  const pages = ["RecordPayment", "UploadPayments", "RecordExpenses", "PaymentApproval", "CreatePayment", "Spendings"];
  const page = pages.find((candidate) => canAccessRoute(`/Main/${candidate}`));
  return page ? `/Main/${page}` : null;
}

export default function PaymentTabs() {
  const page = useLocation().pathname.split("/")[2];
  const activePage = ["Spendings", "Convert"].includes(page) ? "PaymentApproval" : page;
  return (
    <nav className="payment-tabs" aria-label="Payments">
      {paymentTabs.filter((tab) => canAccessRoute(`/Main/${tab.page}`)).map((tab) => (
        <Link key={tab.page} to={`/Main/${tab.page}`} aria-current={activePage === tab.page ? "page" : undefined}>{tab.label}</Link>
      ))}
    </nav>
  );
}